/**
 * Created by Viacheslav Stepanian on 27.08.2026
 */

const WeeklyGoalsFlag = function (index, options) {
    options = options || {};

    return Prefab.instantiate(bundles.weekly_goals.jsons.weekly_goals_flag_prefab_json, {
        index,
        onSelect: options.onSelect
    });
};
